import { Controller } from "@hotwired/stimulus"

// Lets a plain vertical mouse wheel scroll a horizontally-overflowing table
// sideways when the cursor is over it. macOS overlay scrollbars are invisible
// and unreachable for mouse-only users, so wide dashboard tables on low-res
// screens were impossible to scroll across. Falls through to normal page
// scrolling once the table reaches its left/right edge, so vertical scrolling
// still works. Attach to a container that wraps the `.overflow-x-auto` tables.
export default class extends Controller {
  connect() {
    this.onWheel = this.onWheel.bind(this)
    this.element.addEventListener("wheel", this.onWheel, { passive: false })
  }

  disconnect() {
    this.element.removeEventListener("wheel", this.onWheel)
  }

  onWheel(event) {
    // Leave native horizontal (trackpad) gestures alone — only redirect a
    // dominantly-vertical wheel.
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return

    const scroller = event.target.closest(".overflow-x-auto")
    if (!scroller || !this.element.contains(scroller)) return
    if (scroller.scrollWidth <= scroller.clientWidth) return // no horizontal overflow

    let delta = event.deltaY
    if (event.deltaMode === 1) delta *= 16 // lines -> approx pixels
    else if (event.deltaMode === 2) delta *= scroller.clientWidth // pages

    const atStart = scroller.scrollLeft <= 0
    const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1
    if (delta < 0 && atStart) return // let the page scroll up
    if (delta > 0 && atEnd) return   // let the page scroll down

    scroller.scrollLeft += delta
    event.preventDefault()
  }
}
